export const ucFirst = (str) => {
  if (typeof (str) !== 'string') {
    return ''
  }

  if (!str?.trim()) {
    return ''
  }

  return str.split(' ').map((item) => `${item.charAt(0).toUpperCase()}${item.slice(1).toLowerCase()}`).join(' ')
}

export const ucFirstLetter = (str) => {
  if (typeof (str) !== 'string') {
    return ''
  }

  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const generateTimes = (selectedDate) => {
  const times = [];

  const now = new Date();
  const selected = new Date(selectedDate);

  const isToday =
    now.getFullYear() === selected.getFullYear() &&
    now.getMonth() === selected.getMonth() &&
    now.getDate() === selected.getDate();

  const currentMinutes = isToday
    ? now.getHours() * 60 + now.getMinutes()
    : 0;

  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const totalMinutes = h * 60 + m;

      if (totalMinutes >= currentMinutes) {
        const hour = h.toString().padStart(2, "0");
        const minute = m.toString().padStart(2, "0");
        times.push(`${hour}:${minute}`);
      }
    }
  }

  return times;
};


export const middleTruncate = (text = '', head = 10, tail = 10, maxLength = 65) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.slice(0, head)}...${text.slice(-tail)}`;
};
